import React, { useEffect, useState } from "react";
import { GetLocalStorageParsed } from "../../Utils/Utils";
import { oldDocumentData } from "../../services/api/user";
import Dashboard from "../../pages/Dashboard/Dashboard";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { useLanguage } from "../LanguageProvider/LanguageProvider ";
import { Link } from "react-router-dom";

const OldDocument = () => {
  const userDetail = GetLocalStorageParsed("userDetail");
  const { language, setLanguage } = useLanguage();
  const [documentData, setDocumentData] = useState(null);

  useEffect(() => {
    fetchOldDocumentData();
  }, []);

  const fetchOldDocumentData = async () => {
    try {
      const formData = new FormData();
      formData.append("unique_id", userDetail?.unique_id);
      const details = await oldDocumentData(formData);
      if (details && details?.categories && details?.categories.length > 0) {
        setDocumentData(details?.categories);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  const filteredDocumentData = documentData?.filter(item => item.files && item.files.length > 0);

  // Function to download all files as a ZIP
  const downloadAllFiles = (category) => {
    const zip = new JSZip();
    category.files.forEach((file, index) => {
      zip.file(file.name, fetch(file.path).then(res => res.blob()));
    });

    zip.generateAsync({ type: "blob" }).then((content) => {
      saveAs(content, `${category.category}_files.zip`);
    });
  };

  const formatCategory = (category) => {
    return category
      .split('-')              // Split the string by hyphen
      .map(word =>             // Capitalize the first letter of each word
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(' ');              // Join the words back together with a space
  };

  return (
    <Dashboard
      first={language ? "होम" : "Home"}
      second={language ? "पुराने दस्तावेज़" : "Old Documents"}
      head={language ? "पुराने दस्तावेज़" : "Old Documents"}
    >
      <>
        <div className="aod-bottom">
          <div className="page_heading">
            <h5>{language ? "पुराने दस्तावेज़" : "Old Documents"}</h5>
          </div>
          <div className="row">
            <div className="reciept-table table-responsive mt-2">
              <table
                className="table table mb-0 dataTable transaction_table"
                id="receipt_table"
                role="grid"
              >
                <thead>
                  <tr role="row">
                    <th>{language ? "क्रम संख्या" : "S.No"}</th>
                    <th>{language ? "उपश्रेणी" : "Sub Category"}</th>
                    <th>{language ? "कार्रवाई" : "Action"}</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredDocumentData?.length > 0 ? (
                    filteredDocumentData?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{formatCategory(item.category)}</td>
                        <td>
                        <Link
                            to="/old-document-view"
                            state={{ fileData: item.files }}
                          >
                            <button className="btn btn-green-view me-2 mb-2">
                              {language ? "दस्तावेज़ देखें" : "View Files"}
                            </button>
                          </Link>
                          <button
                            className="btn btn-green-view me-2 mb-2"
                            onClick={() => downloadAllFiles(item)}
                          >
                            {language ? "डाउनलोड करें (ज़िप के रूप में)" : "Download (Zip)"}
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4">
                        {language ? "कोई दस्तावेज़ नहीं मिला" : "No documents found"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </>
    </Dashboard>
  );
};

export default OldDocument;
